import Cookies from "js-cookie";
import Services from "./Services";
// import { IVP_CLIENT_ID, IVP_LOGIN_URL } from "./config";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import DOMPurify from "dompurify";
import React from "react";
import { makeStyles } from "tss-react/mui";

// secureFlag is used to check if the current protocol is HTTPS or HTTP

export function setCookieStorage(key, value, options = {}) {
  // Determine secure flag based on current protocol
  const secureFlag =
    window.location.protocol === "https:"
      ? { secure: true, sameSite: "strict" }
      : { secure: false, sameSite: "lax" };

  // Merge options with secureFlag and provided options
  const cookieOptions = { ...secureFlag, ...options };

  // Set the cookie
  Cookies.set(key, value, cookieOptions);
}

export function getCookieStorage(key) {
  return Cookies.get(key);
}

export function removeCookieStorage(key) {
  Cookies.remove(key);
}

export const formatDate = (date) => {
  if (!date) return ""; // or return a default value, e.g. 'N/A'
  const dateArray = date.split("-");
  return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
};

// For IVP

// export const logout = () => {
//   const refToken = Cookies.get("refresh_token_ivp");
//   console.log("refToken", refToken);
//   let body = {
//     refresh_token: refToken,
//   };
//   console.log("body", body);

//   try {
//     Services.IVPLogout(body).then((res) => {
//       if (res.status === 200) {
//         removeCookieStorage("LoggedIn");
//         removeCookieStorage("access_token_ivp");
//         removeCookieStorage("refresh_token_ivp");
//         removeCookieStorage("client_code");
//         removeCookieStorage("user_role");
//         removeCookieStorage("ivpflag");
//         removeCookieStorage("first_name");
//         removeCookieStorage("last_name");

//         const currentPath = window.location.pathname;
//         if (currentPath === "/homepage") {
//           window.location.reload();
//         } else {
//           window.location.href = `${IVP_LOGIN_URL}/loginRedirect?client_id=${IVP_CLIENT_ID}`;
//         }
//       }
//     });
//   } catch {
//     console.log("error");
//     window.location.href = `${IVP_LOGIN_URL}/loginRedirect?client_id=${IVP_CLIENT_ID}`;
//   }
// };
export const logout = () => {
  removeCookieStorage("LoggedIn");
  removeCookieStorage("access_token_ivp");
  removeCookieStorage("refresh_token_ivp");
  removeCookieStorage("client_code");
  removeCookieStorage("user_role");
  removeCookieStorage("ivpflag");
  removeCookieStorage("first_name");
  removeCookieStorage("last_name");

  window.location.href = `/homepage`;
};

export const validateAccessToken = async () => {
  const cookiesTokenValue = Cookies.get("access_token_ivp");
  const cookiesRefToken = Cookies.get("refresh_token_ivp");

  if (cookiesTokenValue) {
    const decodeToken = jwtDecode(cookiesTokenValue);
    const token_expireTime = decodeToken.exp;
    const current_time = Math.floor(Date.now() / 1000);
    if (decodeToken) {
      if (current_time >= token_expireTime) {
        // if (1 == 1) {
        const refreshToken = Cookies.get("refresh_token_ivp");
        const clientID = virtualconference;
        const bodyjson = {
          refresh_token: refreshToken,
        };
        try {
          const response = await Services.validateAccessTokengenByRefreshToken(
            bodyjson,
            clientID
          );
          if (response.status === 200) {
            const newAccessToken = response.data.data.access_token;
            let refreshToken = response.data.data.refresh_token;
            // Cookies.set("access_token_ivp", newAccessToken, {
            //   // expires: 1,
            //   ...secureFlag,
            // });
            setCookieStorage("access_token_ivp", newAccessToken);
            setCookieStorage("refresh_token_ivp", refreshToken);
          }
        } catch (error) {
          console.error("Error refreshing access token:", error);
          Swal.fire({
            title: "Error",
            text:
              error.response?.data?.errors ||
              "Session has expired, Kindly login again",
            icon: "error",
          }).then(function () {
            // Cookies.remove("access_token_ivp");
            // Cookies.remove("refresh_token_ivp");
            // localStorage.clear();
            // window.location.href = "/";
          });
          return;
        }
      }
    }
  }
  if (cookiesRefToken) {
    const decodeRefToken = jwtDecode(cookiesRefToken);
    const refToken_expireTime = decodeRefToken.exp;
    const current_time = Math.floor(Date.now() / 1000);
    if (current_time >= refToken_expireTime) {
      Swal.fire({
        title: "Error",
        text: "Session has expired, Kindly login again",
        icon: "error",
      }).then(function () {
        logout();

        // Cookies.remove("access_token_ivp");
        // Cookies.remove("refresh_token_ivp");
        // localStorage.clear();
        // window.location.href = "/homepage";
      });
    }
  }
};

export const fetchUserData = async () => {
  // let body = { user_id: Cookies.get("client_code") };   FOR ivp link
  let body = { user_id: "e727d79a-87f9-45dd-99a5-ed3748ee98b9" }; //organiser
  // let body = { user_id: "aa92145c-3d1e-4593-9d23-6fd5c05945b8" }; //user
  // let body = { user_id: "52454b15-f545-48ad-8280-f9ec51dd086e" }; //reviewer
  const res = await Services.getConferenceUserDetails(body);
  if (res.status === 200) {
    return res.data.data;
  } else {
    return null;
  }
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const SanitizedHTML = ({ html, plainText }) => {
  const useStyles = makeStyles()((theme) => ({
    divider: {
      margin: `${theme.spacing(3)} 0`,
    },
    sanitizedHTMLContainer: {
      "& img": {
        maxWidth: "100%",
        height: "auto",
        display: "block",
        margin: "0 auto",
      },
      "& ol, & ul": {
        listStyleType: "disc",
        paddingLeft: theme.spacing(2),
      },
      "& ol": {
        listStyleType: "decimal",
      },
      "& ul": {
        listStyleType: "disc",
      },
    },
  }));
  let { classes } = useStyles();

  const resolveRelativeUrls = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");
      if (src && !src.startsWith("http") && !src.startsWith("//")) {
        img.setAttribute("src", `${baseUrl}/${src}`);
      }
    });
    const serializer = new XMLSerializer();
    return serializer.serializeToString(doc.body);
  };
  const resolvedHTML = resolveRelativeUrls(html);
  const sanitizedHTML = DOMPurify.sanitize(resolvedHTML);

  return (
    // <div
    //   className={classes.sanitizedHTMLContainer}
    //   dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    // />

    <>
      {html ? (
        <div
          className={classes.sanitizedHTMLContainer}
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        />
      ) : (
        <div>{plainText}</div>
      )}
    </>
  );
};

// utils/validationUtils.js
export const validateField = (name, value, validationRules, currentErrors) => {
  const errors = { ...currentErrors };
  const rules = validationRules[name];

  let errorMessage = "";

  // Validate the input value against each rule
  for (let rule of rules) {
    if (!rule.rule(value)) {
      errorMessage = rule.message;
      break; // S\ at the first validation failure
    }
  }

  // Update the errors object
  if (errorMessage) {
    errors[name] = errorMessage;
  } else {
    delete errors[name]; // Remove the key if there's no error
  }

  return errors;
};

export const validateForm = (fields, rules) => {
  const errors = {};

  Object.keys(rules).forEach((field) => {
    const value = fields[field];
    const fieldRules = rules[field];

    fieldRules.forEach((rule) => {
      const { rule: validationRule, message } = rule;
      if (!validationRule(value)) {
        errors[field] = message;
      }
    });
  });

  return errors;
};

export const formatErrorMessages = (errors) => {
  // check if errors is an object
  if (typeof errors !== "object") {
    return errors;
  }
  let errorMessage = '<div style="white-space: pre-line;">'; // Use CSS to control line breaks
  for (const field in errors) {
    if (errors.hasOwnProperty(field)) {
      errorMessage += `${field}: ${errors[field]}\n`; // Include newline for each error message
      //
    }
  }
  errorMessage += "</div>";
  return errorMessage;
};
